<template>
  <the-layout>
    <mobile v-if="$store.getters.isMobile"></mobile>
    <desktop v-else></desktop>
  </the-layout>
</template>
<script>
import Desktop from "./Desktop.vue";
import Mobile from "./Mobile.vue";
export default {
  name: "search-list",
  components: {
    Desktop,
    Mobile,
  },
};
</script>
